import { Modal, Form } from "react-bootstrap";
import ModalHead from "../../../../common/ui/ModalHead";
import ErrorAlert from "../../../../common/ui/ErrorAlert";

/* ⚠ id="txtAuthOtp" / name="authotp" are read by handleChangeOtpFields. Do not
   rename either.

   ⚠ The resend control is gated on ResendOtpCountdownSeconds === 0. App.js
   starts that at 15 and ticks it down, but nothing ever showed it — so for the
   first fifteen seconds the link simply was not there, and a customer whose SMS
   had not arrived had no way to tell whether resending was possible at all.
   The countdown is now rendered in that gap. Same gate, same state, just
   visible. */
export default function OtpModalPage(props) {
    const formData = props.loyaltyMember.OtpModalPage;
    const seconds = props.loyaltyMember.ServerCalls.ResendOtpCountdownSeconds;
    let spinnerResendOtp = props.loyaltyMember.ServerCalls.SendOtpSms ? <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></> : <></>
    let isDisabled = props.loyaltyMember.ServerCalls.SendOtpSms ?
        {
            pointerEvents: "none",
            color: "#21252980"
        }:
        {}

    return (
        <>
            <ModalHead title="Sign in" onBack={props.handleBackOtpPage} backDisabled={formData.GeneralError.ButtonsDisabled} />
            <Modal.Body className="wo-loy__body">
                <div className="wo-loy__intro">
                    <h3 className="wo-loy__head">Enter your code</h3>
                    <p className="wo-loy__sub">
                        We sent a one time password to{' '}
                        <strong>{props.loyaltyMember.MobileModalPage.Fields.authmobile.Value}</strong>.
                    </p>
                </div>

                <div className="wo-loy__form">
                    <Form.Floating>
                        <Form.Control type="tel" id="txtAuthOtp" name="authotp" placeholder="Code" inputMode="numeric" autoComplete="one-time-code" className={formData.Fields.authotp.HasError ? "is-invalid" : ""} value={formData.Fields.authotp.Value} onChange={props.handleChangeOtpFields} maxLength={formData.Fields.authotp.MaxLength} disabled={formData.GeneralError.ButtonsDisabled}></Form.Control>
                        <Form.Control.Feedback type="invalid">{formData.Fields.authotp.ErrorMessage}</Form.Control.Feedback>
                        <label htmlFor="txtAuthOtp">Code</label>
                    </Form.Floating>

                    { formData.GeneralError.HasError && <ErrorAlert message={formData.GeneralError.ErrorMessage} /> }

                    <button type="button" className="wo-btn wo-btn--primary" onClick={props.handleNextValidateOtp} disabled={formData.GeneralError.ButtonsDisabled}>
                        Verify
                        { formData.GeneralError.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></> }
                    </button>

                    { !formData.GeneralError.ButtonsDisabled && (seconds === 0
                        ? <div className="wo-loy__resend">
                            <a href="#" onClick={props.handleResendOtpToMobile} style={isDisabled}>Send a new code{spinnerResendOtp}</a>
                          </div>
                        : <p className="wo-loy__resendWait">
                            Didn&rsquo;t get it? You can ask for a new code in {seconds}s
                          </p>) }

                    <div className="wo-loy__or"><span>or</span></div>

                    <button type="button" className="wo-btn wo-btn--ghost" onClick={props.handleClickCloseLoyaltyModal} disabled={formData.GeneralError.ButtonsDisabled}>Continue as guest</button>
                </div>
            </Modal.Body>
        </>
    )
}
